import { Decodable } from './_decodable';

class PagePost extends Decodable {
  id: number;
  accountPageSettingsId: number;
  image: string;
  title: string;
  description: string;
  order: number;
  createdAt: string;
  updatedAt: string;
}

export { PagePost };
